// @ts-nocheck
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import parseQueryString from "@insite/client-framework/Common/Utilities/parseQueryString";
import { getSearchHistory, SearchHistoryItem } from "@insite/client-framework/Services/AutocompleteService";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import getAutocompleteModel from "@insite/client-framework/Store/CommonHandlers/GetAutocompleteModel";
import sendAutocompleteOdpEvent from "@insite/client-framework/Store/CommonHandlers/SendAutocompleteOdpEvent";
import sendSearchTracking from "@insite/client-framework/Store/CommonHandlers/SendSearchTracking";
import {
    getSelectedCategoryPath,
    getSettingsCollection,
} from "@insite/client-framework/Store/Context/ContextSelectors";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import translate from "@insite/client-framework/Translate";
import { AutocompleteItemModel, AutocompleteModel } from "@insite/client-framework/Types/ApiModels";
import AutocompleteBrands, {
    AutocompleteBrandsStyles,
} from "@insite/content-library/Widgets/Header/AutocompleteBrands";
import AutocompleteCategories, {
    AutocompleteCategoriesStyles,
} from "@insite/content-library/Widgets/Header/AutocompleteCategories";
import AutocompleteContent, {
    AutocompleteContentStyles,
} from "@insite/content-library/Widgets/Header/AutocompleteContent";
import AutocompleteProducts, {
    AutocompleteProductsStyles,
} from "@insite/content-library/Widgets/Header/AutocompleteProducts";
import AutocompleteSuggestions, {
    AutocompleteSuggestionsStyles,
} from "@insite/content-library/Widgets/Header/AutocompleteSuggestions";
import SearchHistory, { SearchHistoryStyles } from "@insite/content-library/Widgets/Header/SearchHistory";
import { FormFieldSizeVariant } from "@insite/mobius/FormField";
import { sizeVariantValues } from "@insite/mobius/FormField/formStyles";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
// import Search from "@insite/mobius/Icons/Search"; // Starter Custom Code
import Popover, {
    ContentBodyProps,
    OverflowWrapperProps,
    PopoverPresentationProps,
    PositionStyle,
} from "@insite/mobius/Popover";
import TextField, { TextFieldPresentationProps } from "@insite/mobius/TextField";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import VisuallyHidden from "@insite/mobius/VisuallyHidden";
import debounce from "lodash/debounce";
import throttle from "lodash/throttle";
import React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css, ThemeProps, withTheme } from "styled-components";
import { startSearch } from "@insite/client-framework/Store/CommonHandlers/StartSearch";

/* Starter Custom Code - Start */
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import getColor from "@insite/mobius/utilities/getColor";
import constants from "@store/constants";
import getContentSearchUrl from "@store/Framework/Common/Utilities/getContentSearchUrl";
import updateSearchFields from "@store/Framework/Store/Starter/Pages/ProductList/Handlers/UpdateSearchFields";
import { getContentSearchCurrentTab } from "@store/Framework/Store/Starter/Pages/ProductList/ProductListSelectors";
import { getContentSearchParameter } from "@store/Framework/Store/Starter/Pages/ProductList/ProductListSelectors";
import Search from "@store/Components/Toolkit/Icons/Search";
import { autocompleteFontStyles } from "@store/Themes/common/mixins/autocomplete";
import { linkActionStyles } from "@store/Themes/common/mixins/link";
import { buttonGetFieldIconProps } from "@store/Themes/common/props/button";
import breakpoint from "@store/Framework/Common/Utilities/breakpoint";
import mergeProps from "@store/Framework/Common/Utilities/mergeProps";
import { pxToRem } from "@store/Framework/Common/Utilities/unitHelper";
import { focusStyles } from "@store/Themes/common/mixins/common";

const getColumnProps = (width: string): InjectableCss => ({
    css: css`
        flex: 1 1 auto;
        width: ${pxToRem(width)};
        max-width: 100%;
    `,
});

const autocompleteWrapperStyles = css`
    display: flex;
    flex: 1 0 auto;
    gap: ${pxToRem(16, 20)};
    max-height: 100%;

    ${breakpoint("sm", "down")} {
        flex-wrap: wrap;
    }
`;
/* Starter Custom Code - End */

interface OwnProps {
    /** A unique identifier to assist with id-generation for `aria-controls`. */
    readonly id: string;
    inputRef?: React.Ref<HTMLInputElement>;
    autocompletePositionFunction?: (element: React.RefObject<HTMLUListElement | null>) => PositionStyle;
    onBeforeGoToUrl?: () => void;
    extendedStyles?: SearchInputStyles;
    isAnimated?: boolean;
}

const mapStateToProps = (state: ApplicationState) => {
    const {
        searchSettings: { autocompleteEnabled, searchHistoryEnabled, searchHistoryLimit, searchPath },
        extensionContentSearchSettings, // Starter Custom Code
    } = getSettingsCollection(state);
    /* Starter Custom Code - Start */
    const enableContentSearchResults =
        extensionContentSearchSettings && extensionContentSearchSettings.enableContentSearchResults;
    const contentSearchCurrentTab = enableContentSearchResults ? getContentSearchCurrentTab(state) : "";
    const contentSearchParameter = enableContentSearchResults ? getContentSearchParameter(state) : {};
    /* Starter Custom Code - End */
    return {
        autocompleteEnabled,
        searchHistoryEnabled,
        searchHistoryLimit,
        location: getLocation(state),
        searchPath,
        // Starter Custom Code
        contentSearchCurrentTab,
        contentSearchParameter,
        enableContentSearchResults,
    };
};

const mapDispatchToProps = {
    getAutocompleteModel,
    sendSearchTracking,
    sendAutocompleteOdpEvent,
    startSearch,
    // Starter Custom Code
    updateSearchFields,
};

type Props = OwnProps &
    ThemeProps<BaseTheme> &
    HasHistory &
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps>;

interface State {
    query: string;
    focusableAutocompleteItems: AutocompleteItemModel[];
    focusedAutocompleteItem?: AutocompleteItemModel;
    focusedSearchHistoryQuery?: string;
    autoCompleteModel?: AutocompleteModel | null;
    isLoading: boolean;
    clickedProduct: boolean;
}

const DOWN_KEY = 40;
const UP_KEY = 38;
const ENTER_KEY = 13;

export interface SearchInputStyles {
    input?: TextFieldPresentationProps;
    popover?: PopoverPresentationProps;
    popoverWrapper?: OverflowWrapperProps;
    popoverContentBody?: ContentBodyProps;
    autocompleteWrapper?: InjectableCss;
    autocompleteColumnWrapper?: InjectableCss;
    autocompleteCommerceSearchWrapper?: InjectableCss;
    searchHistoryStyles?: SearchHistoryStyles;
    autocompleteSuggestionsStyles?: AutocompleteSuggestionsStyles;
    autocompleteCategoriesStyles?: AutocompleteCategoriesStyles;
    autocompleteBrandsStyles?: AutocompleteBrandsStyles;
    autocompleteContentStyles?: AutocompleteContentStyles;
    autocompleteProductsStyles?: AutocompleteProductsStyles;
    // Starter Custom Code
    popoverContentWrapper?: InjectableCss;
    popoverContentResults?: InjectableCss;
    autocompleteColumnProductWrapper?: InjectableCss;
    viewAllLink?: LinkPresentationProps;
}

export const searchInputStyles: SearchInputStyles = {
    /* Store Custom Code - Start */
    input: mergeProps<TextFieldPresentationProps>(buttonGetFieldIconProps(Search), {
        mergeCss: true,
        sizeVariant: "xsmall" as any,
        cssOverrides: {
            inputSelect: css`
                border-width: 1px !important;
                border-color: ${getColor("common.borderDark")};
            `,
        },
    }),
    /* Store Custom Code - End */
    popover: {
        transitionDuration: "short",
        toggle: false,
    },
    popoverWrapper: {
        as: "div",
        _height: "auto",
    },
    popoverContentBody: {
        as: "div",
        _height: "none",
        css: css`
            right: 50%;
            top: 100%;
            box-shadow: none;
            overflow: visible;
            min-width: 100%;
            color: ${getColor("text.main")};
            background-color: transparent;
            transform: translateX(50%);
            transition: none;

            ${breakpoint("sm", "down")} {
                max-width: 100%;
            }
        `,
    },
    popoverContentWrapper: {
        css: css`
            ${autocompleteFontStyles()}
            overflow-y: auto;
            background-color: ${getColor("common.background")};
            border-radius: inherit;

            ${({ theme }) => css`
                box-shadow: ${theme.shadows.e60};
            `}

            ${breakpoint("sm")} {
                overflow-y: initial;
            }
        `,
    },
    popoverContentResults: {
        css: css`
            padding: ${pxToRem(20, 36)};
        `,
    },
    autocompleteWrapper: {
        css: autocompleteWrapperStyles,
    },
    autocompleteCommerceSearchWrapper: {
        css: autocompleteWrapperStyles,
    },
    autocompleteColumnWrapper: getColumnProps("245"),
    autocompleteColumnProductWrapper: getColumnProps("375"),
    viewAllLink: {
        css: css`
            ${x => x.theme.link.defaultProps?.css}
            ${linkActionStyles()}
            ${focusStyles(true)}
            width: 100%;
            justify-content: center;
            margin-top: ${x => x.theme.design.autocomplete.columnHeader.margin.horizontal};
            padding: ${pxToRem(10, 0, 8)};
        `,
    },
};

const styles = searchInputStyles;

class SearchInput extends React.Component<Props, State> {
    private readonly styles: SearchInputStyles;

    constructor(props: Props) {
        super(props);

        this.styles = mergeProps<typeof styles>(styles, props.extendedStyles); // Starter Custom Code
        const parsedQuery = parseQueryString<{ query?: string }>(this.props.location.search);

        this.state = {
            query: parsedQuery.query || "",
            focusableAutocompleteItems: [],
            isLoading: false,
            clickedProduct: true,
        };
    }

    list = React.createRef<HTMLUListElement>();
    popover = React.createRef<any>();
    showAutocomplete = true;

    componentDidUpdate(prevProps: Props, prevState: State) {
        if (this.props.location.pathname !== prevProps.location.pathname) {
            // clear the search box on navigate away from search
            if (!this.props.location.pathname.toLowerCase().startsWith(`/${this.props.searchPath.toLowerCase()}`)) {
                // TODO ISC-12679 - Redesign so that this can be moved to a field of the class rather than state.
                this.setState({ query: "" });
            } else {
                this.closeAutocomplete();
            }
        }
        /* Starter Removed - && prevState.autoCompleteModel */
        if (this.state.autoCompleteModel && this.state.autoCompleteModel !== prevState.autoCompleteModel) {
            this.updateFocusableItems();
        }
    }

    componentDidMount() {
        window.addEventListener("resize", this.handleResize, true);
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.handleResize);
    }

    handleResize = () => {
        this.updateFocusableItems();
    };

    /* Starter Custom Code - Start */
    handleViewAllLink = () => {
        const contentSearchPrefixUrl = getContentSearchUrl(
            this.state.query,
            this.props.searchPath,
            this.props.contentSearchCurrentTab || constants.contentSearch.tabKey.products,
        );
        this.goToUrl(contentSearchPrefixUrl, false);
    };
    /* Starter Custom Code - End */

    updateFocusableItems = () => {
        if (this.state.isLoading || !this.state.autoCompleteModel) {
            return;
        }

        const { categories, brands, content, products } = this.state.autoCompleteModel;
        /* Starter Removed - isProductsOnTop */
        const newFocusableOptions = (products || ([] as AutocompleteItemModel[]))
            .concat(categories || [])
            .concat(brands || [])
            .concat(content || []); // Starter Custom Code
        this.setState({
            focusableAutocompleteItems: newFocusableOptions,
            focusedAutocompleteItem: undefined,
            focusedSearchHistoryQuery: undefined,
        });
    };

    doSearch = () => {
        if (this.state.query.trim() === "") {
            return;
        }

        this.showAutocomplete = false;

        /* Starter Custom Code - Start */
        if (
            this.props.enableContentSearchResults &&
            this.state.autoCompleteModel?.products?.length &&
            this.state.autoCompleteModel?.products?.length > 1
        ) {
            this.props.updateSearchFields({
                ...this.props.contentSearchParameter,
                /*
                Can't send query here because of the "Did you mean" or "Search results for" of products, 
                we need the corrected query to update the params
                */
                currentTab: this.props.contentSearchCurrentTab || constants.contentSearch.tabKey.products,
                cpage: undefined,
            });
        }
        /* Starter Custom Code - End */

        this.props.startSearch({
            query: this.state.query,
            autocompleteModel: this.state.autoCompleteModel || undefined,
            searchPath: this.props.searchPath,
            goToUrl: this.goToUrl,
            searchHistoryEnabled: this.props.searchHistoryEnabled,
            searchHistoryLimit: this.props.searchHistoryLimit,
        });
    };

    loadAutocomplete = debounce((query: string) => {
        this.props.getAutocompleteModel({
            query,
            onSuccess: result => {
                if (this.showAutocomplete) {
                    this.setState({
                        autoCompleteModel: result,
                    });
                    this.openAutocomplete();
                }
            },
            onComplete(resultProps) {
                if (resultProps.apiResult) {
                    this.onSuccess?.(resultProps.apiResult);
                }
            },
        });
    }, 200);

    handleInputChange = (event: React.ChangeEvent<HTMLInputElement>, toggleAutoComplete = true) => {
        this.showAutocomplete = toggleAutoComplete;
        const newQuery = event.target.value;
        this.setState({ query: newQuery, autoCompleteModel: null }, () => {
            this.loadAutocomplete(newQuery);
        });
    };

    openAutocomplete = () => {
        this.popover.current && (this.popover.current! as any).openPopover();
    };

    closeAutocomplete = () => {
        this.popover.current && (this.popover.current! as any).closePopover();
    };

    getPopoverPosition = (element: React.RefObject<HTMLUListElement | null>) => {
        if (this.props.autocompletePositionFunction) {
            return this.props.autocompletePositionFunction(element);
        }

        const positionStyle: PositionStyle = {
            position: "absolute", // Starter Custom Code
        };

        /* Starter Removed Code */

        return positionStyle;
    };

    moveFocus = throttle((direction: "prev" | "next") => {
        if (this.state.query) {
            this.setState(({ focusedAutocompleteItem, focusableAutocompleteItems }) => {
                const focusableQueue =
                    direction === "prev" ? focusableAutocompleteItems.slice().reverse() : focusableAutocompleteItems;
                const focusedIndex = focusableQueue.indexOf(focusedAutocompleteItem as AutocompleteItemModel);
                const newFocusedOption = focusableQueue.find((_, index) => index > focusedIndex);
                return { focusedAutocompleteItem: newFocusedOption };
            });
        } else {
            this.setState(({ focusedSearchHistoryQuery }) => {
                const searchHistoryItems = getSearchHistory();
                const focusableQueue = direction === "prev" ? searchHistoryItems.slice().reverse() : searchHistoryItems;
                const focusedSearchHistoryItem = focusableQueue.find(o => o.query === focusedSearchHistoryQuery);
                const focusedIndex = focusableQueue.indexOf(focusedSearchHistoryItem as SearchHistoryItem);
                const newFocusedOption = focusableQueue.find((_, index) => index > focusedIndex);
                return { focusedSearchHistoryQuery: newFocusedOption?.query };
            });
        }
    }, 100);

    handlePopoverKeyDown = (event: KeyboardEvent) => {
        switch (event.keyCode) {
            case DOWN_KEY:
                this.moveFocus("next");
                break;
            case UP_KEY:
                this.moveFocus("prev");
                break;
            case ENTER_KEY:
                if (this.state.focusedAutocompleteItem) {
                    this.goToUrl(this.state.focusedAutocompleteItem.url);
                } else if (this.state.focusedSearchHistoryQuery) {
                    this.setState({ query: this.state.focusedSearchHistoryQuery }, () => {
                        this.doSearch();
                    });
                } else {
                    this.doSearch();
                }
                break;
            default:
                break;
        }
    };

    handlePopoverClose = () => {
        if (!this.state.clickedProduct && (this.state.autoCompleteModel?.products?.length ?? 0) > 0) {
            this.props.sendAutocompleteOdpEvent({});
        }

        this.setState({
            clickedProduct: false,
        });

        this.setState({
            focusedAutocompleteItem: undefined,
            focusedSearchHistoryQuery: undefined,
        });
    };

    trackAutcompleteSearchResults = () => {
        // Make sure only to trigger for autocomplete results
        if (!this.state.query || !this.props.autocompleteEnabled || !this.state.autoCompleteModel) {
            return;
        }

        const { categories, brands, content, products } = this.state.autoCompleteModel;
        const resultCount =
            (products?.length ?? 0) + (categories?.length || 0) + (content?.length || 0) + (brands?.length || 0);
        if (resultCount > 0) {
            // Track an autocomplete of 1+ items
            this.props.sendSearchTracking({
                searchEvent: "autocompleteSearchResults",
                searchTerm: this.state.query,
                resultCount,
                productCount: products?.length,
                categoryCount: categories?.length,
                contentCount: content?.length,
                brandCount: brands?.length,
            });
            return;
        }

        // Track zero resultCount search results and triggers from this.doSearch
        this.props.sendSearchTracking({
            searchEvent: "searchResults",
            searchTerm: this.state.query,
            resultCount,
        });
    };

    goToUrl = (url: string, track = true) => {
        const data = {
            searchQuery: this.state.query,
            searchPosition:
                this.state.autoCompleteModel?.suggestions?.findIndex(o => o.url === url) ??
                this.state.autoCompleteModel?.products?.findIndex(o => o.url === url) ??
                -1,
            attributionToken: this.state.autoCompleteModel?.attributionToken,
        };

        if (data.searchPosition >= 0) {
            this.props.sendAutocompleteOdpEvent(data);
            this.setState({ clickedProduct: true });
        }

        this.props.onBeforeGoToUrl && this.props.onBeforeGoToUrl();
        if (track) {
            this.trackAutcompleteSearchResults();
        }
        this.closeAutocomplete();
        this.setState({
            // don't use stale results on next search and go to wrong PDP
            autoCompleteModel: undefined,
        });

        this.props.history.push(url);
    };

    renderAutocomplete = () => {
        if (!this.props.autocompleteEnabled) {
            return null;
        }

        if (!this.state.autoCompleteModel) {
            return null;
        }

        const {
            categories,
            brands,
            content,
            products,
            suggestions,
            popularBrands,
            popularCategories,
            isRetailSearchCompletionResults,
        } = this.state.autoCompleteModel;

        return (
            <>
                {isRetailSearchCompletionResults &&
                    ((suggestions && suggestions.length > 0) ||
                        (categories && categories.length > 0) ||
                        (popularCategories && popularCategories.length > 0) ||
                        (brands && brands.length > 0) ||
                        (popularBrands && popularBrands.length > 0)) && (
                        <StyledWrapper
                            {...this.styles.autocompleteCommerceSearchWrapper}
                            className="autocomplete-commerce-search-wrapper"
                        >
                            <StyledWrapper
                                {...this.styles.autocompleteColumnWrapper}
                                className="autocomplete-column-wrapper"
                            >
                                {suggestions && suggestions.length > 0 && (
                                    <AutocompleteSuggestions
                                        suggestions={suggestions}
                                        focusedItem={this.state.focusedAutocompleteItem}
                                        goToUrl={this.goToUrl}
                                        extendedStyles={this.styles.autocompleteSuggestionsStyles}
                                    />
                                )}
                                {((categories && categories.length > 0) ||
                                    (popularCategories && popularCategories.length > 0)) && (
                                    <AutocompleteCategories
                                        categories={categories}
                                        popularCategories={popularCategories}
                                        focusedItem={this.state.focusedAutocompleteItem}
                                        goToUrl={this.goToUrl}
                                        extendedStyles={this.styles.autocompleteCategoriesStyles}
                                        isRetailSearchCompletionResults={isRetailSearchCompletionResults}
                                    />
                                )}
                                {((brands && brands.length > 0) || (popularBrands && popularBrands.length > 0)) && (
                                    <AutocompleteBrands
                                        brands={brands}
                                        popularBrands={popularBrands}
                                        focusedItem={this.state.focusedAutocompleteItem}
                                        goToUrl={this.goToUrl}
                                        extendedStyles={this.styles.autocompleteBrandsStyles}
                                        isRetailSearchCompletionResults={isRetailSearchCompletionResults}
                                    />
                                )}
                            </StyledWrapper>
                        </StyledWrapper>
                    )}

                {!isRetailSearchCompletionResults && (
                    <>
                        {/* Starter Custom Code - Start */}
                        {products && products.length > 0 && (
                            <StyledWrapper
                                {...this.styles.autocompleteColumnProductWrapper}
                                className="autocomplete-column-wrapper"
                            >
                                <AutocompleteProducts
                                    products={products}
                                    focusedItem={this.state.focusedAutocompleteItem}
                                    goToUrl={this.goToUrl}
                                    extendedStyles={this.styles.autocompleteProductsStyles}
                                />
                            </StyledWrapper>
                        )}
                        {/* Starter Custom Code - End */}
                        {((categories && categories.length > 0) ||
                            (brands && brands.length > 0) ||
                            (content && content.length > 0)) && (
                            <StyledWrapper /* Starter Custom Code */
                                {...this.styles.autocompleteWrapper}
                                className="autocomplete-wrapper"
                            >
                                <StyledWrapper
                                    {...this.styles.autocompleteColumnWrapper}
                                    className="autocomplete-column-wrapper"
                                >
                                    <AutocompleteCategories
                                        categories={categories}
                                        focusedItem={this.state.focusedAutocompleteItem}
                                        goToUrl={this.goToUrl}
                                        extendedStyles={this.styles.autocompleteCategoriesStyles}
                                    />
                                    <AutocompleteBrands
                                        brands={brands}
                                        focusedItem={this.state.focusedAutocompleteItem}
                                        goToUrl={this.goToUrl}
                                        extendedStyles={this.styles.autocompleteBrandsStyles}
                                    />
                                    <AutocompleteContent
                                        content={content}
                                        focusedItem={this.state.focusedAutocompleteItem}
                                        goToUrl={this.goToUrl}
                                        extendedStyles={this.styles.autocompleteContentStyles}
                                    />
                                </StyledWrapper>
                                {/* Starter Moved - AutocompleteProducts - Up */}
                            </StyledWrapper>
                        )}
                    </>
                )}
            </>
        );
    };

    /* Starter Custom Code - Start */
    hasSearchResults() {
        const { categories, brands, content, products, popularBrands, popularCategories } =
            this.state.autoCompleteModel || {};
        return Boolean(
            categories?.length ||
                brands?.length ||
                content?.length ||
                products?.length ||
                popularBrands?.length ||
                popularCategories?.length,
        );
    }
    /* Starter Custom Code - End */

    render() {
        const { styles } = this;
        const searchId = `headerSearch-${this.props.id}`;

        /* Starter Custom Code - Start */
        const showSearchHistory = Boolean(!this.state.query && this.showAutocomplete && getSearchHistory().length);
        const showSearchResults = Boolean(
            this.state.query && this.props.autocompleteEnabled && this.hasSearchResults(),
        );

        const popoverId = `${searchId}-popover`;
        /* Starter Custom Code - End */

        const searchInput = (
            <TextField
                {...styles.input}
                ref={this.props.inputRef}
                isAnimated={this.props.isAnimated}
                iconClickableProps={{ onClick: this.doSearch, ...styles.input?.iconClickableProps }} // Starter Custom Code
                value={this.state.query}
                onChange={this.handleInputChange}
                placeholder={translate("Search")}
                autoComplete="off"
                clickableText={translate("submit search")}
                id={searchId}
                data-test-selector="headerSearchInputTextField"
                className="search-input"
                // Starter Custom Code
                type="search"
                role="combobox"
                aria-expanded={showSearchHistory || showSearchResults}
                aria-controls={popoverId}
            />
        );

        /* Starter Custom Code - Start */
        const sizeVariant = sizeVariantValues[this.styles?.input?.sizeVariant || ("default" as FormFieldSizeVariant)];

        const popoverContentBodyStyles = mergeProps<ContentBodyProps>(styles.popoverContentBody, {
            css: css`
                border-bottom-right-radius: ${sizeVariant.borderRadius}px;
                border-bottom-left-radius: ${sizeVariant.borderRadius}px;
            `,
        });

        const popoverContentResultsStyles = mergeProps<InjectableCss>(styles.popoverContentResults, {
            css: css`
                ${() => {
                    if (this.props.enableContentSearchResults && this.state.query) {
                        return css`
                            padding-bottom: 0;
                        `;
                    }
                }}
            `,
        });
        /* Starter Custom Code - End */

        return (
            <>
                <VisuallyHidden as="label" htmlFor={searchId} id={`${searchId}-label`}>
                    {translate("Site Search")}
                </VisuallyHidden>
                <Popover
                    {...styles.popover}
                    controlsId={popoverId} // Starter Custom Code
                    ref={this.popover}
                    insideRefs={[this.list]}
                    popoverTrigger={searchInput}
                    positionFunction={this.getPopoverPosition}
                    wrapperProps={styles.popoverWrapper}
                    contentBodyProps={
                        {
                            ref: this.list,
                            ...popoverContentBodyStyles, // Starter Custom Code
                        } as any
                    }
                    handleKeyDown={this.handlePopoverKeyDown}
                    onClose={this.handlePopoverClose}
                    className="popover"
                >
                    {/* Starter Custom Code - Start */}
                    {showSearchHistory || showSearchResults ? (
                        <StyledWrapper {...this.styles.popoverContentWrapper}>
                            <>
                                <StyledWrapper {...popoverContentResultsStyles}>
                                    <StyledWrapper {...this.styles.autocompleteWrapper}>
                                        {!this.state.query && this.showAutocomplete && (
                                            <StyledWrapper {...this.styles.autocompleteColumnWrapper}>
                                                <SearchHistory
                                                    focusedQuery={this.state.focusedSearchHistoryQuery}
                                                    goToUrl={this.goToUrl}
                                                    extendedStyles={styles.searchHistoryStyles}
                                                />
                                            </StyledWrapper>
                                        )}
                                        {this.state.query && this.renderAutocomplete()}
                                    </StyledWrapper>
                                </StyledWrapper>
                                {this.props.enableContentSearchResults && this.state.query ? (
                                    <Link {...this.styles.viewAllLink} onClick={this.handleViewAllLink}>
                                        {translate("View All Results")}
                                    </Link>
                                ) : null}
                            </>
                        </StyledWrapper>
                    ) : null}
                    {/* Starter Custom Code - End */}
                </Popover>
            </>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withHistory(withTheme(SearchInput)));
